import _ from "lodash";
import { ThunkAction } from "redux-thunk";
import { ThunkResult } from "../../shared/utilities";
import { BpmnJsCliWrapper } from "../model/BpmnJsCliWrapper";
import { IAction } from "../model/IAction";
import { ElementType, IElement } from "../model/IProcessData";
import { State } from "../model/State";

export const ADD_GLOBAL_ERROR_HANDLER = "ADD_GLOBAL_ERROR_HANDLER";
export function addGlobalErrorHandlerElement(): AddElementAction {
    return {
        type: ADD_GLOBAL_ERROR_HANDLER,
        element: { id: "globalErrorHandler", type: ElementType.GlobalErrorHandler, name: "GlobalErrorHandler", parameters: {} }
    };
}

export function updateElementName(
    elementId: string | undefined, newName: string)
    : ThunkResult<void, State> {
    return (dispatch) => {
        dispatch<UpdateElementNameAction>({
            type: UPDATE_ELEMENT_NAME,
            elementId: elementId,
            name: newName
        });
        BpmnJsCliWrapper.setLabel(elementId, newName);
    };
}

export const UPDATE_ELEMENT_NAME = "UPDATE_ELEMENT_NAME";

export const BATCH_UPDATE_ELEMENTS = "BATCH_UPDATE_ELEMENTS";
export function batchUpdateElements(batch: BatchUpdateElements): BatchUpdateAction {
    return { type: BATCH_UPDATE_ELEMENTS, batch: batch };
}

export interface BatchUpdateElements {
    added: IElement[];
    updated: IElement[];
    deleted: string[];
}

export interface BatchUpdateAction extends IAction {
    batch: BatchUpdateElements;
}
export interface UpdateElementNameAction extends IAction {
    elementId: string | undefined;
    name: string;
}

export interface AddElementAction extends IAction {
    element: IElement;
}

export const CHANGE_OMIT_RESULT_LOGGING = "CHANGE_OMIT_RESULT_LOGGING";
export function updateLogResult(elementId: string | undefined, newValue: boolean): IUpdateLogResultAction {
    return {
        type: CHANGE_OMIT_RESULT_LOGGING,
        elementId,
        newValue
    };
}

export interface IUpdateLogResultAction extends IAction {
    elementId: string | undefined;
    newValue: boolean;
}

export const CHANGE_SHOULD_DISPOSE = "CHANGE_SHOULD_DISPOSE";
export function updateDisposable(elementId: string | undefined, newValue: boolean): IUpdateDisposableAction {
    return {
        type: CHANGE_SHOULD_DISPOSE,
        elementId,
        newValue
    };
}

export interface IUpdateDisposableAction extends IAction {
    elementId: string | undefined;
    newValue: boolean;
}
